/**
 * ESPELHO do catálogo real do backend — `backend/app/core/feature_catalog.py`,
 * dict `PACKAGES`: trial, starter (297), growth (997), enterprise (2997).
 *
 * - `trial` não é vendável (nasce no signup), por isso fica fora da lista.
 * - NÃO existe pacote `pro`: link antigo com `?package=pro` cai no default.
 * - Gateways: `asaas` está `available=False` no backend; só stripe e manual.
 *
 * Mudou o catálogo lá, mude aqui — `pacotes.test.ts` congela estas listas
 * exatamente para que a divergência apareça como teste vermelho, não como
 * um 422 do backend na cara do cliente.
 */
export const PACOTES_VENDAVEIS = ['starter', 'growth', 'enterprise'] as const;
export const PACOTE_DEFAULT = 'starter';
export const GATEWAYS_DISPONIVEIS = ['stripe', 'manual'] as const;
export const GATEWAY_DEFAULT = 'stripe';

export type PacoteVendavel = (typeof PACOTES_VENDAVEIS)[number];
export type GatewayDisponivel = (typeof GATEWAYS_DISPONIVEIS)[number];
